import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';
import { OrderDetailsResponse } from '../model/orders/orderDetailsDto';

export const getSellerOrderDetails = async (
  orderId: string
): Promise<OrderDetailsResponse> => {
  const endpoint = endpoints.orders.getSellerOrderDetailsV2.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.get<OrderDetailsResponse>(endpoint);
};

export const acceptSellerOrder = async (orderId: string): Promise<void> => {
  const endpoint = endpoints.seller.sellerDetailOrder.setAsAccepted.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.post(endpoint);
};

export const setSellerOrderAsDelivered = async (
  orderId: string
): Promise<void> => {
  const endpoint = endpoints.seller.sellerDetailOrder.setAsDelivered.replace(
    ':orderId',
    orderId
  );
  return await axiosV2.post(endpoint);
};
